import axios from 'axios';

// Axios puro de propósito: a instância `api` injeta Authorization/X-Server,
// que não devem viajar para hosts de terceiros.
export async function getCitiesByUf(uf) {
  const ufValue = typeof uf === 'object' ? uf?.value : uf;

  if (!ufValue || typeof ufValue !== 'string' || ufValue.length !== 2) {
    return [];
  }

  const { data } = await axios.get(
    `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${ufValue}/municipios`
  );

  return data.map(city => ({ value: city.nome, label: city.nome }));
}
